import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { saveAs } from 'file-saver'
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
@Component({
  selector: 'app-comparison',
  templateUrl: './comparison.component.html',
  styleUrls: ['./comparison.component.scss']
})
export class ComparisonComponent implements OnInit {

  constructor(public user: UserService, public http: HttpClient, private spinner: NgxSpinnerService, private toastr: ToastrService) { }

  enhanced_statistic: any;
  have_statistic: any;
  optimized_statistic:any;
  merged_statistics:any;
  Formatdate: any;
  CustomerName: any;
  chaptimizer_percent:any;
  ror:any;
  std_dev:any;
  curbetaValue:any;
  enhancebetaValue:any;
  portfolio_value;


  ngOnInit() {
    if (localStorage.getItem('current_enhanced_statistic') != undefined) {
      this.user.getStatistic(localStorage.getItem('current_enhanced_statistic')).subscribe(statistic => {
        this.enhanced_statistic = statistic;
      });
    }
    if (localStorage.getItem('current_have_statistic') != undefined) {
      this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic => {
        this.have_statistic = statistic;
      });
    }

    this.getFormatdate();

    this.optimized_statistic=this.user.optimized_statistics;

    this.merged_statistics=this.user.merged_statistics;

    if(localStorage.getItem('beta_avg')!=undefined){
      this.curbetaValue=localStorage.getItem('beta_avg');
    }

    if(localStorage.getItem('enhanced_beta')!=undefined){
      this.enhancebetaValue=localStorage.getItem('enhanced_beta');
    }

    this.user.ChaptimizerPercent.subscribe((percent) => {
      this.chaptimizer_percent = percent;
    });

    this.user.Rate_Of_Return.subscribe((percent) => {
      this.ror = percent;
    });

    this.user.StandardDeviationSource.subscribe((percent) => {
      this.std_dev = percent;
    });

    this.user.portfolioValueSource.subscribe(value=>{
      this.portfolio_value=value;
    })

  }



  sendModal() {
    this.CustomerName = (<HTMLInputElement>document.getElementById("customername")).value;
    if (this.CustomerName.length > 0) {
      this.hideModal();
    }
    else if (this.CustomerName !== "") {
      this.showModal();
    }
    (<HTMLInputElement>document.getElementById("customername")).value = '';
    this.getPdf()
  }

  hideModal() {
    document.getElementById('close-modal').click();
  }

  showModal() {
    this.setShowModal(true);
  }

  setShowModal(bool: true) {
  }

  getFormatdate() {
    const today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0');
    var yyyy = today.getFullYear();
    this.Formatdate = mm + '/' + dd + '/' + yyyy;
  }

  getPdf() {
    this.spinner.show();
    let payload = {
      'name': this.CustomerName,
      'portfolio_value': this.portfolio_value,
      'target_value':Number(this.ror),
      'max_standard_deviation':Number(this.std_dev),
      'enhancers': this.user.is_enhanced ? this.user.enhancers:null,
      'chaptimizer_percent': Number(this.chaptimizer_percent),
      'percentages':this.user.portfolio_percentages,
      'current_have_statistic': {'_id':localStorage.getItem('current_have_statistic')},
      'current_enhanced_statistic':{'_id': this.user.is_enhanced ? localStorage.getItem('current_enhanced_statistic'): null},
      'optimized_statistics':this.optimized_statistic?this.optimized_statistic:null,
    }

    this.http.post(this.user.getPdfFileUrl(), payload, { responseType: 'arraybuffer' })
      .subscribe(res => {
        this.spinner.hide()
        if (res.byteLength > 5) {
          var blob = new Blob([res], { type: 'application/pdf' });
          const filename = "Portfolio Enhancer.pdf"
          saveAs(blob, filename)
        }
      },
        (err) => {
          console.log('this is called...')
          this.spinner.hide();
          if (err) {
            this.toastr.error("Something went wrong!")
          }
        })
  }
}
